/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

import { useNavigate } from 'react-router-dom'

import Menu from '../../../../components/CustomerClub/Menu'

import compaignIcon from '../../../../assets/svg/Compaign.svg'

import { notify } from '../../../../components/Toast'

import Table from '../../../../components/CustomerClub/CampaignList'
import { get } from '../../../../services/http'

function index() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate()

  document.title = 'لیست کمپین‌ها'

  const [campaigns, setCampaigns] = useState()
  const [campaignsCount, setCampaignsCount] = useState()
  const [totalPage, setTotalPage] = useState()

  const token = localStorage.getItem('token')

  const handlePageClick = (event) => {
    get(`/api/admin/campaign?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setCampaigns(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setCampaignsCount(response.data.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  useEffect(() => {
    get(`/api/admin/campaign?token=${token}`)
    .then(response => {
      setCampaigns(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setCampaignsCount(response.data.data.total)
    })
    .catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }, [token])

  const navigateHandler = () => {
    navigate('/cc/campaigns/create')
  }

  return (
    <main id='panel'>
      <Menu page={'campaigns'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={compaignIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                کمپین‌ها
              </div>
            </div>
            <div className="left">
              <button onClick={navigateHandler}>ایجاد کمپین</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل‌ کمپین‌ها
              </div>
              <div className="left">
                {campaignsCount}
              </div>
            </div>

            <Table data={campaigns}/>
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>
          

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index